const ShellCard = ({ children, style = {}, className = "" }) => (
  <div
    className={`p-4 ${className}`}
    style={{
      backgroundColor: "#252525",
      borderRadius: "8px",
      ...style,
    }}
  >
    {children}
  </div>
);

export default ShellCard;
